'use strict';

/**
 * @ngdoc function
 * @name thothApp.controller:QuotationNewCtrl
 * @description
 * # ProductNewCtrl
 * Controller of the thothApp
 */
angular.module('thothApp.controllers')
  .controller('QuotationNewCtrl', [
    '$scope', '$state', '$stateParams', 'Quotation', 'ProductCatalog', '$rootScope', 'GoogleApi',
     'toaster', '$mdDialog', 'Prospect',
  function ($scope, $state, $stateParams, Quotation, ProductCatalog, $rootScope, GoogleApi, toaster, $mdDialog, Prospect) {
    const HOUR_DURATION = 60 * 60 * 1000;
    $scope.prospectList = [];
    $scope.productCatalogList = [];
    $scope.selectedProduct = 4;
    $rootScope.rootPath = {
      url: '',
      id: '',
    };
    $scope.prospectHash = {
      'name': '',
      'drive_root_id': '',
      'drive_root_url': ''
    };
    $scope.quotationHash = {
      quotation: {
        'contact_name': '',
        'prospect_id': '',
        'product_catalog_id': '',
        'event_url': '',
        'event_id': '',
        prospect_hash: {
          'name': '',
          'drive_root_id': '',
          'drive_root_url': ''
        },
        'audit_comment': ''
      }
    };
    const message = 'Estimado (a) [[contact_name]]\n\n\nLe saludo de nueva cuenta por este medio, y de acuerdo al útlimo contacto que tuvimos, le informo sobre un par de opciones para realizar la demo vía remota de nuestra herramienta SIGLO/PLD.NET para el cumplimiento en materia de PLD.\n\nLa información del evento indica mi disponibilidad, pero de ser necesario se pueden proponer otras fechas.\n\nFavor de confirmar el dia y horario que mejor se acomode a sus actividades, para hacerles llegar el meeting con la herramienta que me indiquen utilizar para llevar a cabo la demostración antes mencionada.\n\nAsí mismo, adjunto al presente nuestro brochure y un breve cuestionario para brindarles una cotización personalizada, de acuerdo a las necesidades de su empresa. Estos se encuentran en el la informacion del evento.\n\nSin otro particular, quedo de ustedes.\n\n\n\nSaludos.'
    $scope.eventHash = {
      'summary': '',
      'description': message,
      'start': {
        'dateTime': new Date()
      },
      'end': {
        'dateTime': ''
      },
      'attendees': [],
      'attachments': []
    };
    $scope.attendees = ''
    $scope.duration = 1;
    $scope.eventHash.start.dateTime.setSeconds(0,0);


    //vars needed to change the event message dynamically
    let lastContactLength = 0;
    let replacePos = 0;
    // Changes the [[contact_name]] tag in the event desciption
    $scope.replaceContactName = function() {
      var length = $scope.quotationHash.quotation.contact_name.length;
      if(length == 0) {
        if(replacePos >= 0) {
          $scope.eventHash.description = $scope.eventHash.description.substring(0, replacePos) + '[[contact_name]]' + $scope.eventHash.description.substring(replacePos + lastContactLength);
        }
      } else {
        if(lastContactLength == 0) {
          replacePos = $scope.eventHash.description.search('[[contact_name]]') - 13;
          lastContactLength = 16;
        }
        if(replacePos >= 0) {
          $scope.eventHash.description = $scope.eventHash.description.substring(0, replacePos) + $scope.quotationHash.quotation.contact_name + $scope.eventHash.description.substring(replacePos + lastContactLength);
        }
      }
      lastContactLength = length;
    };

    if($stateParams.quotationId) {
      Quotation.find($stateParams.quotationId).then(function(response) {
        $scope.quotationHash = { 'quotation': response.data.quotation };
        $scope.quotationHash.quotation.prospect_id = response.data.quotation.prospect.id;
        $scope.quotationHash.quotation.product_catalog_id = response.data.quotation.product_catalog.id;
        $scope.selectedProduct = response.data.quotation.product_catalog.id;
        $scope.prospectHash = response.data.quotation.prospect.prospect;
      }, function(error) {
        Quotation.error(error);
      });
    }

    $scope.addAttachments = function() {
      $scope.eventHash.attachments = [];
      for(const product of $scope.productCatalogList) {
        if(product.id == $scope.selectedProduct) {
          var urls = {
            'fileUrl': product.form_url || "",
            'mimeType': 'application/vnd.google-apps.form',
            'title': 'CUESTIONARIO PRELIMINAR'
          };
          if(urls.fileUrl.includes('https')) {
            $scope.eventHash.attachments.push(urls);
          };
          urls = {
            'fileUrl': product.brochure_url || "",
            'mimeType': 'application/pdf',
            'title': 'BROCHURE INFORMATIVO'
          };
          if(urls.fileUrl.includes('https')) {
            $scope.eventHash.attachments.push(urls);
          };
        }
      }
    };

    $scope.addAttendee = function() {
      var emails = $scope.attendees.match(/[a-zA-Z0-9-_.+]+@[a-zA-Z0-9-_.+]+/g);
      if (emails) {
        emails.forEach(function(email) {
          $scope.eventHash.attendees.push({'email': email});
        });
        $scope.attendees = '';
      } else {
        toaster.pop('warning', 'Invitados', 'Verifuqie que los correos ingresados esten correctos.')
      }
    };

    $scope.removeAttendee = function(index) {
      $scope.eventHash.attendees.splice(index,1);
    };

    $scope.showComment = function() {
      $scope.title = "Guardar";
      var currentScrollPosition = window.scrollY;
      $mdDialog.show({
        controller: $rootScope.QuoteCommentCtrl,
        templateUrl: 'views/quote_comment_dialogue.html',
        scope: $scope,
        preserveScope: true,
        onRemoving: function() {
          window.scrollTo(0, currentScrollPosition);
        }
      }).then(function(result) {
        $scope.quotationHash.quotation.audit_comment = result.comment;
        $scope.saveQuotation();
      }, function() {
      });
    }

    $scope.saveQuotation = function() {
      $scope.eventHash.end.dateTime = new Date($scope.eventHash.start.dateTime);
      $scope.eventHash.end.dateTime.setTime($scope.eventHash.end.dateTime.getTime() + ($scope.duration * HOUR_DURATION));
      $scope.quotationHash.quotation.product_catalog_id = $scope.selectedProduct;

      if($scope.quotationHash.quotation.event_id === "") {
        GoogleApi.createCalendarEvent($scope.eventHash).then(function(response) {
          //Update Calendar data
          $scope.quotationHash.quotation.event_url = response.result.htmlLink;
          $scope.quotationHash.quotation.event_id = response.result.id;
          delete $scope.quotationHash.prospect_hash;
          Quotation.save($scope.quotationHash).then((response) => {
            $state.go('app.quotations.show', {quotationId: response.data.quotation.id});
          }).catch((error) => {
            Quotation.error(error);
          });
        }, function(error) {
          console.log(error);
          toaster.pop('error', 'Error', 'Hubo un error en la creación del evento');
        });
      } else {
        Quotation.save($scope.quotationHash).then((response) => {
          $state.go('app.quotations.show', {quotationId: response.data.quotation.id});
        }).catch((error) => {
          Quotation.error(error);
        });
      }
    };

    const getAllParams = () => {
      const productPromise = ProductCatalog.index({params: {per_page: 'all', by_column: {"column": "name", "order": "ASC"}}}).then((response) => {
        $scope.productCatalogList = response.data.products;
        $scope.addAttachments();
      }).catch((error) => {
        ProductCatalog.error(error);
      });

      const prospectPromise = Prospect.index({params: {per_page: 'all', by_is_client: false}}).then((response) => {
        $scope.prospectList = response.data.prospects;
      }).catch((error) => {
        Prospect.error(error);
      });

      return Promise.all([productPromise, prospectPromise]);
    }

    // START MAIN
    getAllParams();

  }]);
